import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const CTASection = ({ onWaitlistClick }) => {
  return (
    <section
      className="section-padding relative overflow-hidden"
      data-testid="cta-section"
    >
      <div className="max-w-3xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="govt-panel p-10 md:p-14">
            <p className="section-label mb-5">Membership</p>

            <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-semibold text-[#0F1B2D] tracking-tight mb-6">
              Membership is by verification only
            </h2>

            <p className="text-sm text-[#4A4640] font-medium leading-relaxed mb-4">
              AINAA membership requires verification and recommendation from a minimum of 3 existing platform members. This ensures every member of the Association meets the standard of professional conduct the industry relies on.
            </p>

            <p className="text-sm text-[#4A4640] font-medium leading-relaxed mb-8">
              Submit your details to join the waitlist. The Association will review your credentials and match you with member verifiers. No application is processed without three independent endorsements.
            </p>

            <button
              onClick={onWaitlistClick}
              className="btn-ainaa-primary px-8 py-3.5 text-sm font-semibold flex items-center gap-2.5 uppercase tracking-wider"
              data-testid="cta-apply-btn"
            >
              Join the Waitlist
              <ArrowRight size={16} />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
